import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { filter } from 'rxjs';

@Component({
  selector: 'app-base-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, BreadcrumbModule],
})
export class BaseBreadcrumbComponent {
  items: MenuItem[] = [];
  home: MenuItem = {
    icon: 'dialog-home-icon dialog-icon',
    routerLink: 'home',
  };
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.buildBreadCrumbs();
      });
    this.buildBreadCrumbs();
  }

  buildBreadCrumbs() {
    this.items = [];
    let currentRoute = this.activatedRoute.root.children[0],
      url = '';
    let lastItem = '';
    do {
      const childrenRoutes = currentRoute.children;
      currentRoute = null;
      childrenRoutes.forEach((route) => {
        if (route.outlet === 'primary' && route.snapshot?.data?.title) {
          const routeSnapshot = route.snapshot;
          if (lastItem != routeSnapshot.data.title) {
            lastItem = routeSnapshot.data.title;
            url +=
              '/' + routeSnapshot.url.map((segment) => segment.path).join('/');
            this.items.push({
              label: this.translateService.instant(routeSnapshot.data.title),
              routerLink: url,
            });
          }
          currentRoute = route;
        }
      });
    } while (currentRoute);
  }
}
